/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import renderIf from 'render-if';
import cn from 'classnames';
import SchoolTile from 'components/SchoolTile';
import SchoolListView from 'components/SchoolListView';
import Nocontentfound from '../Tutorial/Nocontentfound';
import styles from '../DashboardView.scss';
import LoadMore from '../LoadMore';

const CollegeView = (props) => {
  // let countForSchool = 0;
  const { contactedList, schools, wishList, fillQList, inviteToCampList, addToList, gridView,
          profileId, addToRequest, removeFromList, showCounterpopUp, addNotification,
          contactedCount, loadmoreColleges, subscribed } = props;
  const renderNoContentFound = renderIf(schools.size === 0 && subscribed);
  // let trialEndDate = '';
  // if (props.profile.get('trialEndDate') !== undefined) {
  //   trialEndDate = props.profile.get('trialEndDate');
  // }
  return (
    <div className={cn('col s12', styles.alignCenter)}>
      {renderNoContentFound(<Nocontentfound text="" />)}
      {schools.map((item) => {
        const interested = contactedList.indexOf(item.get('id')) > -1;
        // if (countForSchool >= 50 || interested) {
        if (interested) {
          // // eslint-disable-next-line no-console
          // console.log('count', countForSchool);
          return null;
        }
        // countForSchool++; //eslint-disable-line
        const wishListId = wishList.indexOf(item.get('id'));
        const inWishList = wishListId > -1;
        const fillQ = fillQList.indexOf(item.get('id')) > -1;
        const inviteToCamp = inviteToCampList.indexOf(item.get('id')) > -1;
        return (
          <span>
            {gridView ?
              <SchoolTile
                saSchool={item}
                addToList={addToList}
                profileId={profileId}
                addToRequest={addToRequest}
                inWishList={inWishList}
                interested={interested}
                removeFromList={removeFromList}
                wishListId={wishListId}
                showCounterScreen={showCounterpopUp}
                {...props}
                fillQ={fillQ}
                inviteToCamp={inviteToCamp}
                showSnackBar={val => addNotification(val)}
                usedFor="schools"
              />
              :
              <SchoolListView
                saSchool={item}
                addToList={addToList}
                profileId={profileId}
                addToRequest={addToRequest}
                inWishList={inWishList}
                interested={interested}
                removeFromList={removeFromList}
                wishListId={wishListId}
                showCounterScreen={showCounterpopUp}
                {...props}
                fillQ={fillQ}
                inviteToCamp={inviteToCamp}
                showSnackBar={val => addNotification(val)}
                usedFor="schools"
              />
            }
          </span>
        );
      })}
      <LoadMore loadmoreColleges={loadmoreColleges} contactedCount={contactedCount} />
    </div>
  );
};

CollegeView.propTypes = {
  addToList: PropTypes.func.isRequired,
  addToRequest: PropTypes.func.isRequired,
  wishList: PropTypes.shape.isRequired,
  contactedList: PropTypes.shape.isRequired,
  fillQList: PropTypes.shape.isRequired,
  inviteToCampList: PropTypes.shape.isRequired,
  profileId: PropTypes.string.isRequired,
  removeFromList: PropTypes.func.isRequired,
  gridView: PropTypes.bool.isRequired,
  showCounterpopUp: PropTypes.func.isRequired,
  addNotification: PropTypes.func.isRequired,
  schools: PropTypes.shape.isRequired,
  contactedCount: PropTypes.number.isRequired,
  loadmoreColleges: PropTypes.func.isRequired,
  subscribed: PropTypes.bool.isRequired,
};

export default CollegeView;




// WEBPACK FOOTER //
// ./src/components/DashboardView/Default/collegeview.js